<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <service-category />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <title-text />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <slug-text />
        </b-col>
        <b-col cols="12">
          <summary-text />
        </b-col>
        <b-col cols="12" md="6">
          <ordering />
        </b-col>
        <b-col cols="12" md="6">
          <url />
        </b-col>
        <b-col cols="12">
          <content-text />
        </b-col>
      </b-row>
    </b-card>
    <video-embed />
    <image-file />
    <!--    <photo-gallery />-->
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'

import ServiceCategory from '@/views/Admin/Services/elements/ServiceCategory.vue'
import TitleText from '@/views/Admin/Services/elements/Title.vue'
import SlugText from '@/views/Admin/Services/elements/Slug.vue'
import SummaryText from '@/views/Admin/Services/elements/Summary.vue'
import ContentText from '@/views/Admin/Services/elements/Content.vue'
// import ImageCard from '@/views/Admin/Services/elements/Image.vue'
import ImageFile from '@/views/Admin/Services/elements/ImageFile.vue'
// import PhotoGallery from '@/views/Admin/Services/elements/PhotoGallery.vue'
import Ordering from '@/views/Admin/Services/elements/Ordering.vue'
import VideoEmbed from '@/views/Admin/Services/elements/VideoEmbed.vue'
import Url from '@/views/Admin/Services/elements/Url.vue'

export default {
  name: 'ItemForm',
  components: {
    Url,
    BCard,
    BRow,
    BCol,
    BButton,
    ServiceCategory,
    TitleText,
    SummaryText,
    ContentText,
    // ImageCard,
    // PhotoGallery,
    Ordering,
    ImageFile,
    SlugText,
    VideoEmbed,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['services/dataItem']
    },
  },
}
</script>
